import { createContext } from 'react';

const ModalContentContext = createContext();

export default ModalContentContext;
